'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../../external/classnames/index.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var RssBlock = function RssBlock(props) {
  var dividerBottom = props.dividerBottom,
    dividerTop = props.dividerTop,
    feedLink = props.feedLink,
    header = props.header,
    text = props.text;
  var classes = index.default('rss-block', dividerBottom && 'divider-bottom', dividerTop && 'divider-top', header && 'padding-bottom');
  var ulClasses = index.default('rss-block-list');
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: classes,
    "data-testid": "lanl-rss-block"
  }, header && /*#__PURE__*/React__default.default.createElement("h3", {
    className: "sidebar-header"
  }, header), /*#__PURE__*/React__default.default.createElement("div", {
    className: "rss-block-list"
  }, /*#__PURE__*/React__default.default.createElement("ul", {
    className: ulClasses
  }, /*#__PURE__*/React__default.default.createElement("li", null, /*#__PURE__*/React__default.default.createElement("a", {
    href: feedLink,
    type: "button",
    "aria-label": "Subscribe to Feed"
  }, /*#__PURE__*/React__default.default.createElement("i", {
    className: "fas fa-rss",
    "aria-hidden": "true"
  }), text)))));
};
RssBlock.defaultProps = {
  bgWhite: false,
  dividerBottom: false,
  dividerTop: false
};
RssBlock.propTypes = {
  feedLink: PropTypes__default.default.string.isRequired,
  text: PropTypes__default.default.string.isRequired,
  bgWhite: PropTypes__default.default.bool,
  dividerBottom: PropTypes__default.default.bool,
  dividerTop: PropTypes__default.default.bool,
  header: PropTypes__default.default.string
};

exports.RssBlock = RssBlock;
exports.default = RssBlock;
//# sourceMappingURL=RssBlock.js.map
